import { FC } from "react";
import { DeploymentStatus } from "../api/common/models/DeploymentStatus";
import { getStatusStyle } from "./getStatusStyle";

export const DeploymentStatusLabel: FC<{ status: DeploymentStatus }> = ({ status }) => {
  const style = getStatusStyle(status)
  return <div className={`text-[10px] font-medium rounded-sm px-1 w-20 text-center uppercase tracking-wide text-white ${style.bg}`}>{style.text}</div>
}
